module.exports = __webpack_public_path__ + "static/schlitten2-d2a00ff63ab784e24d9f69e8523a370f.jpg";